<template>
  <div class="aboutUsPage">
    <img src="../assets/AboutUs/banner_new02.png" alt="" class="banner">
    <div class="panel1">
      <img src="../assets/AboutUs/horizontalLogo02.png" alt="" class="horizontalLogo">
      <br/>
      <img src="../assets/AboutUs/line.png" alt="">
      <div class="listPanel">
        <div class="listItem">
          <img src="../assets/AboutUs/topImg.png" alt="" style="opacity: 0.8;">
          <div class="white1">上海程多多电子商务有限公司</div>
          <div class="white2">电子商务有限公司</div>
          <div class="black">商旅管理 技术开发</div>
        </div>
        <div class="listItem">
          <img src="../assets/AboutUs/topImg.png" alt="" style="opacity: 0.8;">
          <div class="white1">上海程多多电子商务有限公司</div>
          <div class="white2">国际旅行社有限公司</div>
          <div class="black">旅游 团建 会务会展</div>
        </div>
        <div class="listItem">
          <img src="../assets/AboutUs/topImg.png" alt="" style="opacity: 0.8;">
          <div class="white1">上海程多多电子商务有限公司</div>
          <div class="white2">航空服务有限公司</div>
          <div class="black">旅业机票供应商</div>
        </div>
      </div>
    </div>
    <div class="chineseTitle">500+知名企业差旅管理指定服务商</div>
    <div class="englishTitle">— Designated Service Provider —</div>
    <div class="travelManagement">
      <div class="content">
        <div class="text1">上海程多多电子商务有限公司专注商旅服务17年，是中国东方航空指定差旅管理服务商，全球GBTA商旅组织会员，政府指定机票供应商，致力于为企业提供一站式、数字化商旅管理服务，已为中国包括党政事业机关、民营、外资等近2000家大中型企业提供全面的商旅节省方案。</div>
        <div class="text2">上海程多多电子商务有限公司独创商旅节省六式，围绕省钱、省时、省心的管家式商旅服务，以资源整合、系统技术、管家服务三维一体持续为企业商旅降本增效，驱动业务增长。</div>
      </div>
      <img src="../assets/AboutUs/logo02.png" alt="">
    </div>
    <div class="corporateCulture" style="padding-bottom: 100px;">
      <ul class="clearfix">

          <img src="../assets/AboutUs/ourCulture.jpg" alt="" style="width: 1000px; opacity: 0.8;">

      </ul>

    </div>
    <div class="marketCooperation">
      <div class="left lblock">市场合作</div>
      <div class="right lblock">
        <div>021-6263 1105</div>
        <div>mkt@chengduoduo.com</div>
      </div>
    </div>


  </div>
</template>

<script>
  export default {
    name: 'AboutUs',
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
  @import "../css/Aboutus.less";
</style>



// WEBPACK FOOTER //
// src/pages/AboutUs.vue